<template>
    <vxe-modal
        v-model="isShow"
        :title="title"
        width="1100"
        height="640"
        show-zoom
        resize
        fullscreen
    >
        <div>
            <div>
                <vxe-form :data="toolbar.formData">
                    <vxe-form-item title="总部" field="division">
                        <template #default="{ data }">
                            <vxe-select
                                v-model="data.division"
                                placeholder="全部"
                                :options="toolbar.divisions"
                                clearable
                                style="width: 160px"
                            >
                            </vxe-select>
                        </template>
                    </vxe-form-item>

                    <vxe-form-item title="课程名称" field="course_name">
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.course_name"
                                placeholder="全部"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>

                    <vxe-form-item title="关键字" field="searchKey">
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.searchKey"
                                placeholder="请输入关键字"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>

                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="findData"
                                @keyup.enter="findData"
                                >查询</vxe-button
                            >
                            <vxe-button @click="clear">重置</vxe-button>
                            <vxe-button
                                status="success"
                                @click="add"
                                v-if="false"
                                >新增</vxe-button
                            >
                            <vxe-button @click="exportDataEvent"
                                >导出</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div style="overflow: hidden; height: 100%">
                <vxe-table
                    stripe
                    class="mytable-scrollbar"
                    :data="tableData"
                    :height="tableHeight"
                    show-overflow
                    :row-config="{
                        height: 36,
                        isHover: true,
                        isCurrent: true,
                    }"
                    ref="xTable1"
                >
                    <vxe-column
                        type="seq"
                        field="id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column title="删除" width="50" v-if="isAdmin">
                        <template #default="{ row }">
                            <vxe-button
                                type="text"
                                icon="fa fa-trash-o"
                                @click="removeRowEvent(row)"
                            ></vxe-button>
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="course_name"
                        title="课程名称"
                        width="180"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="course_level_name"
                        title="课程等级"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="course_type_name"
                        title="技术分类"
                        width="140"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="course_period"
                        title="授课日期"
                        width="190"
                        show-overflow
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="teach_method_name"
                        title="授课方式"
                        width="100"
                        show-overflow
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="lecturerName"
                        title="讲师"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="division"
                        title="总部"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="dept"
                        title="部门"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="office"
                        title="科室"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="user_name"
                        title="姓名"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="user_email"
                        title="邮箱"
                        width="140"
                        sortable
                        resizable
                    ></vxe-column>
                     <vxe-column
                        field="enroll_time"
                        title="报名时间"
                        width="140"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="isSignIn"
                        title="是否签到"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="leader_name"
                        title="科长姓名"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="require_name"
                        title="课题名称"
                        width="100"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="require_desc"
                        title="课题简介"
                        width="100"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="sceneBussValue"
                        title="课题价值"
                        width="100"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="require_no"
                        title="需求编号"
                        width="120"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                     <vxe-column
                        field="processID"
                        title="开发编号"
                        width="120"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="empCode"
                        title="员工工号"
                        width="120"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                     <vxe-column
                        field="duration_hours"
                        title="培训学时"
                        width="120"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="processStatus"
                        title="课题状态"
                        width="120"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="remark"
                        title="备注"
                        width="120"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="tablePager.currentPage"
                    v-model:page-size="tablePager.pageSize"
                    :total="tablePager.totalResult"
                    @page-change="handlePageChange"
                    :page-sizes="[
                        10,
                        20,
                        100,
                        { label: '全部数据', value: 10000 },
                    ]"
                    :layouts="[
                        'PrevJump',
                        'PrevPage',
                        'JumpNumber',
                        'NextPage',
                        'NextJump',
                        'Sizes',
                        'FullJump',
                        'Total',
                    ]"
                >
                </vxe-pager>
            </div>
        </div>
    </vxe-modal>
</template>

<script setup>
import {
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
    defineEmits,
    onMounted,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
import XEUtils from "xe-utils";
import { useRouter } from "vue-router";
const router = useRouter();
const { proxy } = getCurrentInstance();
const emit = defineEmits(["flashList"]);
const tableHeight = ref(600);
const tableData = ref([]);

const tablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});

const toolbar = reactive({
    loading: false,
    divisions: [],
    formData: {
        course_name: "",
        division: "",
        searchKey: "",
    },
});

const findData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: tablePager.currentPage,
        pageSize: tablePager.pageSize,
        searchKey: [
            "",
            "",
            toolbar.formData.division,
            toolbar.formData.course_name,
            toolbar.formData.searchKey,
        ],
    };
    proxy.$api.courseManageAPI
        .getCourseEnrollList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            tableData.value = res.data.Data.dataTable;
            tablePager.currentPage = res.data.Data.currentPage;
            tablePager.pageSize = res.data.Data.pageSize;
            tablePager.totalResult = res.data.Data.totalResult;
            tableHeight.value = calTableHeight(res.data.Data.dataTable.length);
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindHQ = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 50,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getHeadquarterList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            // console.log(res.data.Data);
            toolbar.divisions = [];
            for (const item of res.data.Data.dataTable) {
                toolbar.divisions.push({
                    value: item.hqCode,
                    label: item.hqName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const handlePageChange = (params) => {
    tablePager.currentPage = params.currentPage;
    tablePager.pageSize = params.pageSize;
    findData();
};

const calTableHeight = (rowsLength) => {
    let minHeight = window.innerHeight - (65 + 28 + 198);
    let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
    return Math.max(450, calHeight);
};

const clear = () => {
    toolbar.formData.searchKey = "";
    toolbar.formData.division = "";
    toolbar.formData.course_name = "";
};
const exportDataEvent = () => {
    const $table = proxy.$refs.xTable1;
    $table.exportData({ type: "csv" });
};
const removeRowEvent = async (row) => {
    const type = await VXETable.modal.confirm("确定要删除该人员报名吗？");

    if (type === "confirm") {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            currentPage: tablePager.currentPage,
            pageSize: tablePager.pageSize,
            searchKey: [row.id],
        };
        proxy.$api.courseManageAPI
            .deleteCourseEnroll(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "删除成功",
                    status: "success",
                });
                findData();
            })
            .catch((error) => {
                console.log(error);
            });
    }
};

const isShow = ref(false);
const title = ref("培训报名列表");
const openModal = async (row) => {
    isShow.value = true;
    tablePager.currentPage = 1;
    toolbar.formData.course_name = row.course_name;
    findData();
};
const isAdmin = ref(false);
onMounted(() => {
    isAdmin.value = proxy.$store.state.isAdmin == "1";
    bindHQ();
});
defineExpose({ openModal });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
